import { useEffect, useState } from 'preact/hooks';
import { getViewSnapshot, subscribeView } from '../stores/viewStore.js';

export function useKUniView() {
  const [snapshot, setSnapshot] = useState(getViewSnapshot);

  useEffect(() => subscribeView((next) => setSnapshot(next)), []);

  return snapshot;
}
